const context = require.context('.', false, /\.js$/)
context.keys().map(context)
